import React from 'react';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import styled from 'styled-components';

import { useShowCost } from '../../hooks/useShowCost';
import defaults from '../../translations/en.json';

/** 24px high, like the header's other controls; apart from the slider after it. */
const SmallChip = styled(Chip)`
  && {
    height: 24px;
    margin-right: 12px;
    font-size: 12px;
    font-weight: 700;
  }
  && .MuiSvgIcon-root {
    font-size: 16px;
  }
`;

/**
 * Mumms admins only (the widget decides): shows or hides the token split and
 * estimated cost columns of the MAIA grids. Filled while they show.
 */
export const SeeTokensChip = () => {
  const [showCost, setShowCost] = useShowCost();
  return (
    <Tooltip title={defaults.seeTokensTitle}>
      <SmallChip
        size="small"
        clickable
        color={showCost ? 'primary' : 'default'}
        variant={showCost ? 'default' : 'outlined'}
        icon={<MonetizationOnOutlinedIcon />}
        label={showCost ? defaults.hideTokens : defaults.seeTokens}
        aria-pressed={showCost}
        onClick={() => setShowCost(!showCost)}
        data-testid="maia-see-tokens"
      />
    </Tooltip>
  );
};

export default SeeTokensChip;
